import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 0 20px 20px;
`;
